<template>
    <div name="revisit-contract" class="wrapper">
        <loading 
            v-if="isLoading"
        />
        <init 
            v-if="contractStep === 0"
            @goContract="goContract"
            @skip="skip"
            :duplicateDelegation="duplicateDelegation" 
        />
        <input-contract 
            style="box-sizing: border-box;"
            v-if="contractStep === 1"
            @closeContract="closeContract"
            @next="nextContract"
        />
        <contract 
            v-if="contractStep === 2"
            @onClose="closeContract"
            @next="nextContract"
        />
        <add-id 
            v-if="contractStep === 3"
            @onClose="closeContract"
            @next="nextContract"
            @prev="prevContract"
        />
        <complete-contract 
            :duplicateDelegation="duplicateDelegation"
            v-if="contractStep === 4"
            @completeContract="completeContract"
        />   
        <div class="page" v-if="error">
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="onErrorModalClose"
            />
        </div>
    </div>
</template>

<script>
// 재진중 위임장 작성이 없는 경우 진입
// 재진중 위임장 작성이 만료(예정 및 만료)인 경우 진입 
// 계약 로직을 그대로 따라간 뒤
// 해당 페이지 접근하면 생성된 청구 정보 띄우고 
// booking 페이지로 이동 
import focusBackground from '@/components/directives/focusBackground';
import Steps from '@/components/molecules/Steps'
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import BottomButton from '@/components/atoms/BottomButton';
import PageFooter from '@/components/molecules/PageFooter';

import Init from '@/components/organisms/revisit_contract/Init.vue';
import InputContract from '@/components/organisms/revisit_contract/InputContract';
import Contract from '@/components/organisms/revisit_contract/ContractNew'
import AddId from '@/components/organisms/revisit_contract/AddId';
import AdditionInfo from '@/components/organisms/revisit_contract/AdditionInfo';
import CompleteContract from '@/components/organisms/revisit_contract/CompleteContract';

import Constant from '@/constant';
import cookies from '@/utilities/cookie.js';
import Loading from '@/components/molecules/Loading';
import ErrorModal from '@/components/modals/ErrorModal';

export default {
    name: 'revisitContract',
    computed: mapState(['delegateWithAddition', 'pre_delegation_info', 'draftProfile']),
    data: function()
    {
        return {
            contractStep: 0,
            token: null,
            isLoading: false,
            duplicateDelegation: false,
            error: null
        }
    },
    directives: {
        focusBackground
    },
    components: {
        Steps,
        TextLabel,
        BottomButton,
        PageFooter,
        InputContract,
        Contract,
        AddId, 
        Loading,
        ErrorModal,
        Init,
        AdditionInfo,
        CompleteContract
    },
    mounted: function()
    {
        ChannelIO('shutdown')
        if(!this.pre_delegation_info.is_loading)
        {
            this.$router.push({path:"/"})
        }
        
        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'register'}})
        }
        else
        {
            if(this.pre_delegation_info.is_delegated)
            {
                // 이미 
                if(this.pre_delegation_info.expired_at)
                {
                    
                    let cur = new Date();
                    let expire = new Date(this.pre_delegation_info.expired_at);
                    expire.setDate(expire.getDate() - 30);
                    if(cur >= expire)
                    {
                        this.contractStep = 0;
                        this.duplicateDelegation = true;  // 만료 
                    }
                    expire = new Date(this.pre_delegation_info.expired_at);
                    expire.setDate(expire.getDate());
                    if(cur > expire)
                    {
                        this.duplicateDelegation = false;
                    }
                }
                
            }

        }
        
        this.topFunction();
    },
    methods: {
        onErrorModalClose: function()
        {
            this.error = null;
        },
        convertDate: function(date)
        {   
            return `${date.substring(0, 4)}년 ${date.substring(5, 7)}월 ${date.substring(8, 10)}일`;
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        goContract: function()
        {
            this.contractStep = 1;
        },
        closeContract: function()
        {
            this.contractStep = 0;
        },
        prevContract: function(step)
        {
            this.contractStep = step
        },
        nextContract: function(step)
        {
            this.contractStep = step;
        },
        completeContract: function()
        {
            this.isLoading = true;

            this.$store.dispatch(Constant.SAVE_DELEGATE, {profile_id: this.pre_delegation_info.profile_id, token: this.token})
                .then(() => {
                    this.isLoading = false;
                    this.$router.push({path: '/complete'})
                })
                .catch((err) => {
                    this.error = err;
                    this.isLoading = false;
                })
        },
        skip: function()
        {
            this.isLoading = true;
            this.duplicateDelegation = false;
            this.body.delegation_info.agreement_delegate = false;
            this.body.delegation_info.agreement_personal_info = false;
            this.body.delegation_info.agreement_personal_identification_info = false;

            this.files.premedical_files = [];
            this.files.signature_file = null;
            this.files.delegation_docs_file = null;
            this.files.id_card_file = null;

            this.$store.dispatch(Constant.TEMP_SAVE_DIABETES, {token: this.token})
                .then((res) => {

                    this.revisit_request_data.staging_data_index = this.status.staging_data_index;
                    this.revisit_request_data.profile.name = this.body.profile.name;
                    this.revisit_request_data.profile.registration_number = this.body.profile.registration_number;
                    this.revisit_request_data.card_info = null;

                    this.$store.dispatch(Constant.SAVE_REVISIT_DIABETES, {token: this.token})
                        .then(() => {
                            this.isLoading = false;
                            this.$router.push({path: '/complete'})
                        })
                        .catch((err) => {
                            this.error = err;
                            this.isLoading = false;
                        })
                })
                .catch((err) => {
                    this.error = err;
                    this.isLoading = false;
                })
            
        },
        back: function()
        {
            this.$router.push({path: '/apply'})
        }
    }
}
</script>

<style scoped>
.wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        
    }
    .page {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    @media (min-width: 600px) {
        .page {
            width: 600px;
            
        }
        
    }
    .input-area {
        width: 100%;
        padding: 0px 16px 30px 16px;
        border-bottom: 8px solid var(--Gray-sub-color1, #F3F5F8);
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        
    }
    .text-box {
        width: 100%;
        flex-shrink: 0;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        padding: 20px;
        margin-top: 16px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .info-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 18px;
        letter-spacing: -0.42px;
    }
    .info-color-text {
        color: var(--Gray-60, #6B7684);
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }
    .row {
        text-align: center;
    }
    .label {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        margin-top: 20px;
    }
    .text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .text-bold {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .text-info {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.42px;
        text-align: center;
    }
    .bold {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }

    .text-red {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 24px; /* 133.333% */
        letter-spacing: -0.36px;
    }
    .text-normal {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.36px;
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
    }
    .text-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .text-subtitle {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px;
    }
    .text-subtitle-bold {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 22px; /* 122.222% */
    }
    .head-box {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

</style>


// WEBPACK FOOTER //
// src/page/RevisitContract.vue